package dev.wyns.ventrova.platform

import dev.wyns.ventrova.data.model.Place

/** Hand-offs to other apps: maps, phone, browser and the share sheet. */
interface ExternalActions {
    /** Opens walking directions to [place] in the platform's maps app. */
    fun openDirections(place: Place)

    fun call(phone: String)

    fun openWebsite(url: String)

    fun share(place: Place)
}

/** Text shared for a place: name, address and website. */
fun Place.shareText(): String = listOfNotNull(name, address.formatted(), website).joinToString("\n")

/** Website URL with a scheme, as the database sometimes stores bare domains. */
fun normalizedUrl(url: String): String = if (url.startsWith("http://") || url.startsWith("https://")) url else "https://$url"

/** Website without scheme and trailing slash, for display. */
fun displayUrl(url: String): String = url.removePrefix("https://").removePrefix("http://").removePrefix("www.").trimEnd('/')
